import * as React from 'react';
import AssetSettings from '../models/AssetSettings';
import { identity } from '../../core/auth/identityAuth';
import HttpService from '../../../modules/core/services/HttpService';
import { withRouter } from "react-router-dom";
import { Switch, FormGroup, FormControlLabel, Typography, TextField, Grid } from '@material-ui/core';
import Form from '../../shared/components/Form';
import HttpCallConfig from '../../core/models/HttpCallConfig'

const httpService = HttpService.Instance;

class ProviderAssetSettings extends React.Component<any, any> {
  public assetForm: Form
  constructor(props: any) {
    super(props);
    this.getSettings = this.getSettings.bind(this);
    this.saveData = this.saveData.bind(this);
    this.state = {
      isAutoApproveSubscribersEnabledEditable: false,
      isEnabledEditable: false
    }
  }

  public getSettings() {
    if (identity['nxt:entity:id']) {
      return httpService.get(process.env.REACT_APP_API_URL + 'assets/' + this.props.assetId).then((response: Response) => response.json()).then(data => {
        const { isAutoApproveSubscribersEnabledEditable, isEnabledEditable } = data;
        this.setState({ isAutoApproveSubscribersEnabledEditable, isEnabledEditable })
        return httpService.get(process.env.REACT_APP_API_URL + 'entity/' + identity['nxt:entity:id'] + '/assets/' + this.props.assetId + '/generalsettings')
      })
    }
    return null
  }

  public async saveData(data: AssetSettings) {
    if (identity['nxt:entity:id']) {
      const httpCallConfig = new HttpCallConfig;
      httpCallConfig.successMessage = 'Asset settings updated'
      return await httpService.post(process.env.REACT_APP_API_URL + 'entity/' + identity['nxt:entity:id'] + '/assets/' + this.props.assetId + '/generalsettings', data, httpCallConfig)
    }
    return null
  }

  public render() {
    return (
      <div>
        <Typography color="textSecondary" gutterBottom={true}>
          Asset &nbsp; &rang; Settings
        </Typography>
        <Form
          ref={(ref: Form) => this.assetForm = ref}
          history={this.props.history}
          saveFormPromise={this.saveData}
          getFormPromise={this.getSettings}
          refreshHandler={
            (callback?: () => void) => {
              this.forceUpdate(() => {
                if (callback) { callback() }
              })
            }
          }
        >
          {this.assetForm && !this.assetForm.isLoading &&
            <div>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      name="isEnabled"
                      onChange={(e: any) => { this.assetForm.onChangeHandler(e); }}
                      checked={this.assetForm.formShadowData.isEnabled}
                      disabled={!this.state.isEnabledEditable}
                    />
                  }
                  label="Allow usage of your asset"
                />
                <FormControlLabel
                  control={
                    <Switch
                      name="isAutoApproveSubscribersEnabled"
                      checked={this.assetForm.formShadowData.isAutoApproveSubscribersEnabled}
                      onChange={(e: any) => { this.assetForm.onChangeHandler(e); }}
                      disabled={!this.state.isAutoApproveSubscribersEnabledEditable}
                    />
                  }
                  label="Auto approve new subscribers"
                />
              </FormGroup>
              {this.assetForm.formShadowData.hasExternalApi &&
                <Grid container spacing={24}>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="externalApiUrl"
                      label="Api Url"
                      value={this.assetForm.formShadowData.externalApiUrl}
                      onChange={(e: any) => { this.assetForm.onChangeHandler(e) }}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="externalApiUsername"
                      label="Username"
                      placeholder="Stored value invisible"
                      value={this.assetForm.formShadowData.externalApiUsername}
                      onChange={(e: any) => { this.assetForm.onChangeHandler(e) }}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="externalApiPassword"
                      label="Password"
                      placeholder="Stored value invisible"
                      value={this.assetForm.formShadowData.externalApiPassword}
                      onChange={(e: any) => { this.assetForm.onChangeHandler(e) }}
                      margin="normal"
                    />
                  </Grid>
                </Grid>
              }
            </div>
          }
        </Form>
      </div>
    )
  }
}

export default withRouter(ProviderAssetSettings)


// WEBPACK FOOTER //
// ./src/modules/provider/pages/ProviderAssetSettings.tsx